import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import numeral from 'numeral';
import { faPencil, faFloppyDisk } from '@fortawesome/pro-light-svg-icons';
import styles from './IndicatorItem.module.scss';
import styled from 'styled-components';
import LoadingSpinner from 'shared/components/LoadingSpinner';

const IndicatorItem = ({ id, indicatorName, indicatorForecast, handleSaveOrUpdate, resultId, beneficiary, isLoading }) => {
  const [editable, setEditable] = useState(false);
  const [value, setValue] = useState(indicatorForecast);

  const handleEdit = () => {
    if (editable && value !== indicatorForecast) {
      handleSaveOrUpdate({
        forecastCurrent: value,
        indicatorId: id,
        id: resultId
      });
    }
    setEditable(e => !e);
  };

  const handleChangeNumber = (ev) => {
    setValue(ev.target.value);
  };

  const editableStyle = {
    display: 'inline-block',
    width: '32px',
    height: '32px',
    paddingTop: '4px',
    marginLeft: '10px'
  };

  const containerStyle = {
    paddingLeft: '10px',
    paddingRight: '10px'
  };

  return (
    <div style={containerStyle} className={`${styles.indicator__container} ${editable ? 'editable' : ''}`}>
      <div className={styles.indicator__item}>
        <span className={`heading-label ${styles.heading__label}`}>Indicator</span>
        <p>
          {editable
            ? <Input type="number" value={value} onChange={handleChangeNumber} onBlur={handleEdit} />
            : isLoading ? <LoadingSpinner /> : <span className={`display-number ${styles.forecast__item}`} onClick={handleEdit}>
              {numeral(indicatorForecast).format(0, 0)}
            </span>
          }
          <span className={styles.forecast__explainer}> {beneficiary} {indicatorName} </span>
          <div onClick={handleEdit} style={editableStyle} className={`cta-icon__container base ${editable ? 'active' : ''}`}>
            <FontAwesomeIcon icon={editable ? faFloppyDisk : faPencil} />
          </div>
        </p>
      </div>
    </div>
  );
};

export default IndicatorItem;

const Input = styled.input`
  border: none;
  width: 80px;
  height: 35px;
  border-radius: 40px;
  margin-right: 15px;
  font-size: 17px;
  padding-left: 15px;
`;